export const googleReviewMinimumScore = 4;
export const customerCorrectionMinimumScore = 2;